import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useNavigate, useLocation} from "react-router-dom";
import {toast} from "react-toastify";
import {messages} from "../../../../constants/index";
import {
  acknowledgeOnOff,
  resetLimitSensorRequest,
  requestAddSlugFeed,
  requestTestFeed,
  sendDeleteSensorRequest,
} from "../../../../redux/Actions/controllers.actions";
import {toggleModal} from "../../../../redux/Actions/general.actions";
import {storeDataExplorerSensorAnalysis} from "../../../../redux/Actions/data-explorer.actions";

export const useSummaryTableActions = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const url = location.pathname;
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editGroupModelOpen, setEditGroupModelOpen] = useState(false);
  const [resetLimitModalOpen, setResetLimitModalOpen] = useState(false);
  const [sensorSummaryModalOpen, setSensorSummaryModalOpen] = useState(false);
  const [selectedSensorId, setSelectedSensorId] = useState("");
  const [slugModalOpen, setSlugModalOpen] = useState(false);
  const [selectedCheckBoxId, setSelectedCheckBoxId] = useState(0);
  const [turnOnOff, setTurnOnOff] = useState(false);

  const deleteSensorHandler = useCallback(() => {
    dispatch(
      sendDeleteSensorRequest(selectedSensorId.id, () => setDeleteModalOpen(false))
    );
  }, [dispatch, selectedSensorId.id]);

  const turnOnOffHandler = useCallback(() => {
    dispatch(acknowledgeOnOff(selectedCheckBoxId));
    setTurnOnOff(false);
  }, [dispatch, selectedCheckBoxId]);

  const handleTestFeed = useCallback(
    (selectedRow) => {
      dispatch(requestTestFeed(selectedRow));
    },
    [dispatch]
  );

  const onSaveSlugFeed = useCallback(
    (minutes) => {
      dispatch(
        requestAddSlugFeed({id: selectedSensorId.id, minutes}, () =>
          setSlugModalOpen(false)
        )
      );
    },
    [dispatch, selectedSensorId]
  );

  const resetLimitHandler = useCallback(() => {
    try {
      dispatch(
        resetLimitSensorRequest(selectedSensorId.id, () => setResetLimitModalOpen(false))
      );
    } catch (error) {
      toast.error("Error limiting output sensor");
    }
  }, [dispatch, selectedSensorId.id]);

  const handleActionSelection = useCallback(
    (action, selectedRow) => {
      setSelectedSensorId(selectedRow);

      switch (action) {
        case "Edit":
        case "Click":
          navigate(`${url}/sensor/edit/${selectedRow.id}`, {state: {action}});
          break;
        case "Delete":
          setDeleteModalOpen(true);
          break;
        case "Test Feed":
          dispatch(
            toggleModal(
              {
                open: true,
                message: messages.modals.title.confirmTestFeed,
                title: "Test Feed",
              },
              () => handleTestFeed(selectedRow)
            )
          );
          break;
        case "Slug Feed":
          setSlugModalOpen(true);
          break;
        case "Reset Limit":
          setResetLimitModalOpen(true);
          break;
        case "Analysis":
          dispatch(
            storeDataExplorerSensorAnalysis({
              id: selectedRow.id,
              name: selectedRow.description,
            })
          );
          navigate(`${url}/data-explorer`);
          break;
        case "Summary":
          setSensorSummaryModalOpen(true);
          break;
        case "Calibrate":
          navigate(`${url}/calibrate`, {
            state: {id: selectedRow.id, title: selectedRow.title},
          });
          break;
        case "Move":
          setEditGroupModelOpen(true);
          break;
        default:
          break;
      }
    },
    [handleTestFeed, dispatch, navigate, url]
  );

  return {
    deleteModalOpen,
    deleteSensorHandler,
    editGroupModelOpen,
    onSaveSlugFeed,
    resetLimitModalOpen,
    resetLimitHandler,
    selectedSensorId,
    sensorSummaryModalOpen,
    setDeleteModalOpen,
    setEditGroupModelOpen,
    setResetLimitModalOpen,
    setSensorSummaryModalOpen,
    setSlugModalOpen,
    setTurnOnOff,
    slugModalOpen,
    turnOnOff,
    setSelectedCheckBoxId,
    turnOnOffHandler,
    handleActionSelection,
  };
};
